<template>
    <div class="cockpit">
        <div class="index_title">黄石市公共资源交易智慧监管总舱</div>
        <div class="index_content">
            <div class="index_left">
                <div class="index_left_row" v-for="(item, index) in leftData" :key="index" @click="jump(item.img)">
                    <div>{{ item.name }}</div>
                    <img :src="item.url" alt="">
                </div>
            </div>
            <div class="index_middle">
                <div>
                    <img :src="require('@/assets/img/cockpit/index/right.png')" alt="">
                    <img :src="require('@/assets/img/cockpit/index/left_line.png')" alt="">
                </div>
                <div>
                    <img :src="require('@/assets/img/cockpit/index/right_line.png')" alt="">
                    <img :src="require('@/assets/img/cockpit/index/left.png')" alt="">
                </div>
            </div>
            <div class="index_right">
                <div class="index_left_row" v-for="(item, index) in rightData" :key="index" @click="jump(item.img)">
                    <img :src="item.url" alt="">
                    <div>{{ item.name }}</div>
                </div>
            </div>
        </div>
        <div class="footerBottom">
            <div @click="changeActive(item.img)" v-for="(item, index) in footerTitle" :key="index"
                @mouseenter="changeImg(index, 1)" @mouseleave="changeImg(index, 2)">
                <img v-if="item.isShow == false" :src="item.url" alt="">
                <img v-else :src="item.url1" alt="">
                <div :class="item.isShow == false ? '' : 'active'">{{ item.name }}</div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            footerTitle: [
                {
                    name: '主体信用监管',
                    img: '1',
                    url: require('@/assets/img/cockpit/index/footer_1.png'),
                    url1: require('@/assets/img/cockpit/index/footer_11.png'),
                    isShow: false
                },
                {
                    name: '鸟瞰舱',
                    img: '',
                    url: require('@/assets/img/cockpit/index/footer_3.png'),
                    url1: require('@/assets/img/cockpit/index/footer_33.png'),
                    isShow: true
                },
                {
                    name: '项目数智监管',
                    img: '2',
                    url: require('@/assets/img/cockpit/index/footer_2.png'),
                    url1: require('@/assets/img/cockpit/index/footer_22.png'),
                    isShow: false
                },
                // {
                //     name:'大数据N维监管',
                //     img:'4',
                //     url:require('@/assets/img/cockpit/index/footer_4.png'),
                //     url1:require('@/assets/img/cockpit/index/footer_44.png'),
                //     isShow:false
                // },
                // {
                //     name:'服务效能监管',
                //     img:'5',
                //     url:require('@/assets/img/cockpit/index/footer_5.png'),
                //     url1:require('@/assets/img/cockpit/index/footer_55.png'),
                //     isShow:false
                // }
            ],
            leftData: [
                {
                    name: '法人地图',
                    img: '1',
                    url: require('@/assets/img/cockpit/index/left1.png')
                },
                {
                    name: '交易主体人员地图',
                    img: '2',
                    url: require('@/assets/img/cockpit/index/left2.png')
                },
                {
                    name: '项目备案监管',
                    img: '3',
                    url: require('@/assets/img/cockpit/index/left3.png')
                },
                // {
                //     name:'音视频网格化监管',
                //     img:'4',
                //     url:require('@/assets/img/cockpit/index/left4.png')
                // },
                {
                    name: '项目风险预测预警',
                    img: '5',
                    url: require('@/assets/img/cockpit/index/left5.png')
                },
            ],
            rightData: [
                {
                    name: '营商环境分析',
                    img: '6',
                    url: require('@/assets/img/cockpit/index/left6.png')
                },
                {
                    name: '项目开放度分析',
                    img: '18',
                    url: require('@/assets/img/cockpit/index/right1.png')
                },
                {
                    name: '项目活跃度分析',
                    img: '19',
                    url: require('@/assets/img/cockpit/index/right2.png')
                },
                {
                    name: '项目竞争度分析',
                    img: '20',
                    url: require('@/assets/img/cockpit/index/right3.png')
                },
                // {
                //     name:'项目主体画像',
                //     img:'',
                //     url:require('@/assets/img/cockpit/index/right4.png')
                // },
                // {
                //     name:'备案服务效能',
                //     img:'11',
                //     url:require('@/assets/img/cockpit/index/right5.png')
                // },
                // {
                //     name:'场地服务效能',
                //     img:'12',
                //     url:require('@/assets/img/cockpit/index/right6.png')
                // }
            ],
            activeItem: '指标总览'
        }
    },
    mounted() {
        console.log(this.leftData, 1111)
    },
    methods: {
        jump(index) {
            if (index) {
                if (index == 3) {
                    this.$router.push({ name: 'intelligence_index', query: { type: '项目备案监管' } })
                } else if (index == 4) {
                    this.$router.push({ name: 'intelligence_index', query: { type: '音视频网格化监管' } })
                } else if (index == 5) {
                    this.$router.push({ name: 'intelligence_index', query: { type: '项目风险预测预警' } })
                } else if (index == 1) {
                    this.$router.push({ name: 'legalPerson_index', query: { type: '法人地图' } })
                } else if (index == 2) {
                    this.$router.push({ name: 'legalPerson_index', query: { type: '交易主体人员地图' } })
                } else if (index == 11) {
                    this.$router.push({ name: 'service_index', query: { type: '备案服务效能' } })
                } else if (index == 12) {
                    this.$router.push({ name: 'service_index', query: { type: '场地服务效能' } })
                } else if (index == 6) {
                    this.$router.push({ name: 'intelligence_index', query: { type: '营商环境分析' } })
                } else if (index == 18) {
                    this.$router.push({ name: 'cockpit_industry_environment', query: { type: '大数据N维监管', btnActive: 1 } })
                } else if (index == 19) {
                    this.$router.push({ name: 'cockpit_industry_environment', query: { type: '大数据N维监管', btnActive: 2 } })
                } else if (index == 20) {
                    this.$router.push({ name: 'cockpit_industry_environment', query: { type: '大数据N维监管', btnActive: 3 } })
                }
            }

        },
        changeActive(index) {
            if (index == 2) {
                this.$router.push({ name: 'intelligence_index',query:{type:'项目备案监管'} })
            } else if (index == 5) {
                this.$router.replace({ name: 'service_index' })
            } else if (index == 4) {

                this.$router.replace({ name: 'cockpit_industry_environment' })
            } else if (index == 1) {
                this.$router.replace({ name: 'legalPerson_index' })
            }
        },
        changeImg(index, type) {
            if (this.footerTitle[index].name != this.activeItem) {
                this.$set(this.footerTitle[index], 'isShow', !this.footerTitle[index].isShow)
            }

        }
    }
}
</script>
<style lang="scss" scoped>
.cockpit {
    width: 100%;
    height: 100%;
    background: #0C224B;
    background-image: url('../../../assets/img/cockpit/index/bg.png');
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    position: relative;

    .index_title {
        font-size: 40px;
        font-family: FZCuSong-B09S-Regular, FZCuSong-B09S;
        font-weight: 500;
        line-height: 47px;
        letter-spacing: 8px;
        background: linear-gradient(180deg, #FFFFFF 0%, #1890FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-top: 119px;
        text-align: center;
    }

    .index_content {
        display: flex;
        justify-content: center;
        align-items: top;
        margin-top: 70px;
    }

    .index_left {
        position: relative;

        .index_left_row {
            justify-content: flex-end;
            padding-right: 32px;
            background: url('../../../assets/img/cockpit/index/text_bg.png') no-repeat;

            &:hover {
                background: url('../../../assets/img/cockpit/index/text_bg1.png') no-repeat;
            }

            &:nth-of-type(1) {
                right: 0;
            }

            &:nth-of-type(2) {
                right: 47px;
            }

            &:nth-of-type(3) {
                right: 74px;
            }

            &:nth-of-type(4) {
                right: 74px;
            }

            &:nth-of-type(5) {
                right: 47px;
            }

            &:nth-of-type(6) {
                right: 0px;
            }

            img {
                margin-left: 14px;
            }
        }
    }

    .index_left_row {
        position: absolute;
        width: 300px;
        height: 73px;
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.65);
        font-size: 20px;
        cursor: pointer;

        &:nth-of-type(1) {
            top: 0;
        }

        &:nth-of-type(2) {
            top: 105px;
        }

        &:nth-of-type(3) {
            top: 210px;
        }

        &:nth-of-type(4) {
            top: 315px;
        }

        &:nth-of-type(5) {
            top: 420px;
        }

        &:nth-of-type(6) {
            top: 525px;
        }

    }

    .index_middle {
        width: 862px;
    }

    .index_right {
        position: relative;

        .index_left_row {
            justify-content: flex-start;
            padding-left: 32px;
            background: url('../../../assets/img/cockpit/index/text_right1.png') no-repeat;

            &:hover {
                background: url('../../../assets/img/cockpit/index/text_right.png') no-repeat;
            }

            &:nth-of-type(1) {
                left: 0;
            }

            &:nth-of-type(2) {
                left: 47px;
            }

            &:nth-of-type(3) {
                left: 74px;
            }

            &:nth-of-type(4) {
                left: 74px;
            }

            &:nth-of-type(5) {
                left: 47px;
            }

            &:nth-of-type(6) {
                left: 0px;
            }

            img {
                margin-right: 14px;
            }
        }
    }

    .index_middle {
        display: flex;
        justify-content: space-between;
        position: relative;

        &>div {
            position: absolute;
            display: flex;
            align-items: center;

            &:nth-of-type(1) {
                top: 10px;
                left: -47px;

                img:nth-of-type(1) {
                    margin-right: 15px;
                }
            }

            &:nth-of-type(2) {
                top: 10px;
                right: -47px;

                img:nth-of-type(2) {
                    margin-left: 15px;
                }
            }

        }
    }

    .footerBottom {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 135px;
        padding-bottom: 10px;
        background: url('../../../assets/img/cockpit/index/index_footer.png') no-repeat;
        display: flex;
        justify-content: center;

        &>div {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            margin-right: 55px;
            cursor: pointer;

            img {
                margin-bottom: 8px;
                width: 36px;
                height: 36px;
            }

            div {
                line-height: 23px;
                background: linear-gradient(180deg, #5CEDFF 0%, rgba(92, 237, 255, 0.1) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                height: 25px;
                font-size: 20px;

            }
        }

        .active {
            background: linear-gradient(180deg, #FFEAC0 0%, #FFD15C 100%) !important;
            -webkit-background-clip: text !important;
            color: transparent;
        }
    }
}
</style>